import { memo } from "react";
import FormHelperText from "@mui/material/FormHelperText";
import Resources from "../../config/Resources";

// eslint-disable-next-line no-shadow
type EType = "error" | "info";
interface Props {
  className?: string;
  text: string;
  type: EType;
  smokerTextField?: boolean;
}

function CustomErrorText({ text, className, type, smokerTextField }: Props) {
  return (
    <FormHelperText classes={{ root: `!mt-1.5 flex items-center space-x-1  ${className}` }}>
      {type === "error" && (
        <img
          src={Resources.images.Error.icon}
          alt="error"
          className={`h-3.5 w-3.5 ${smokerTextField ? "z-10 mb-0.5  xl:mt-0 lg:mt-0" : ""}`}
        />
      )}
      <span
        className={`text-xxs leading-5 ${
          smokerTextField
            ? "z-10 mb-1 xl:mt-0 lg:mt-0 font-medium whitespace-nowrap"
            : "font-medium font-montserrat whitespace-nowrap"
        } ${type === "error" ? "text-vermilionCinnabar" : "text-platinumGranite"}`}
      >
        {text}
      </span>
    </FormHelperText>
  );
}

CustomErrorText.defaultProps = {
  className: "",
  smokerTextField: false
};
export default memo(CustomErrorText);
